/**
 * Created by Terence on 2023/2/15 - 21:15
 * Description :
 */
export const DEFAULT_AVATAR =
  "https://cdn.qiandaoapp.com/interior/images/ac885575c2c6441583dcfb21dd1cfa72.jpeg";
